import { App } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import React from 'react';

let messageInstance: MessageInstance | null = null;

/**
 * 桥接组件，渲染在 Ant Design <App> 上下文内部，
 * 将组件树内的 message 实例同步给非 React 上下文（如请求拦截器、工具函数）
 */
export const AppMessageBridge: React.FC = () => {
  const { message } = App.useApp();
  React.useEffect(() => {
    messageInstance = message;
    return () => {
      messageInstance = null;
    };
  }, [message]);
  return null;
};

const callMessageMethod = (method: keyof MessageInstance, args: unknown[]) => {
  const handler = messageInstance?.[method];
  return typeof handler === 'function'
    ? (handler as (...values: unknown[]) => unknown)(...args)
    : null;
};

/**
 * 全局单例转发代理，杜绝直接调用静态 message.* 产生的 React 19 / Antd 6 控制台警告
 */
export const appMessage = {
  success: (...args: Parameters<MessageInstance['success']>) =>
    callMessageMethod('success', args),
  error: (...args: Parameters<MessageInstance['error']>) =>
    callMessageMethod('error', args),
  info: (...args: Parameters<MessageInstance['info']>) =>
    callMessageMethod('info', args),
  warning: (...args: Parameters<MessageInstance['warning']>) =>
    callMessageMethod('warning', args),
  loading: (...args: Parameters<MessageInstance['loading']>) =>
    callMessageMethod('loading', args),
};
